"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useAlertDialogState: ()=>useAlertDialogState
});
const external_react_namespaceObject = require("react");
const useAlertDialogState = ()=>{
    const [isAlertDialogActive, setIsAlertDialogActive] = (0, external_react_namespaceObject.useState)(false);
    const observerRef = (0, external_react_namespaceObject.useRef)(null);
    (0, external_react_namespaceObject.useEffect)(()=>{
        const checkAlertDialog = ()=>{
            const alertDialog = document.querySelector('[role="alertdialog"]');
            if (!alertDialog) return;
            const alertDialogParent = alertDialog.parentElement;
            const isVisible = alertDialogParent && 'none' !== window.getComputedStyle(alertDialogParent).display;
            setIsAlertDialogActive(!!isVisible);
        };
        checkAlertDialog();
        observerRef.current = new MutationObserver(checkAlertDialog);
        observerRef.current.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            if (observerRef.current) observerRef.current.disconnect();
        };
    }, []);
    return isAlertDialogActive;
};
exports.useAlertDialogState = __webpack_exports__.useAlertDialogState;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "useAlertDialogState"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
